<script setup lang="ts">
  import zhCn from "element-plus/es/locale/lang/zh-cn"
  import * as commonApis from "@/api/commonApis"
  import { ElMessageBox, ElMessage } from "element-plus"
  
  const getSystemInfo = async () => {
    try {
      const response = await commonApis.getSystemInfo()
      
      if (response.data.data.__version !== window.__version) {
        const result = await ElMessageBox.confirm("当前系统不是最新版本, 是否加载最新系统?", "系统更新", {
          type: "warning"
        }).catch(() => null)
        
        if (result === "confirm") {
          const timestamp = new Date().getTime()
          let search = window.location.search
          search = search ? `${ search }&t=${ timestamp }` : `?t=${ timestamp }`
          window.location.href = `${ window.location.href }${ search }`
        }
      }
    }
    catch (error) {
      console.error(error)
    }
  }
  
  const promptSystemUpdate = async () => {
    // await 等待用户响应, 阻塞下面的代码继续运行, 否则用户一直不响应, 后面的代码也会一直执行
    // 用户一直不响应, 然后弹窗遮罩就会越来越多, 页面变得越来越黑, 只需要存在一个弹窗即可
    await getSystemInfo()
    const timeout = 1000 * 60 * 5
    setTimeout(promptSystemUpdate, timeout)
  }
  
  window.addEventListener(
    "error",
    async (e) => {
      if (sessionStorage.staticReload) {
        return
      }
      let targetElement = e.target as Element
      let targetTagName = targetElement.tagName
      
      if (targetTagName === "SCRIPT" || targetTagName === "LINK") {
        const result = await ElMessageBox.confirm("当前系统不是最新版本， 脚本运行错误， 是否加载最新系统?", "系统更新", {
          type: "warning"
        }).catch(() => {
        })
        
        if (result === "confirm") {
          sessionStorage.setItem("staticReload", "1")
          // 强制刷新
          window.location.reload()
          setTimeout(() => {
            ElMessage({
              type: "success",
              showClose: true,
              message: "欢迎使用新版本，如有问题，请联系管理人员"
            })
          }, 1500)
        }
      }
    },
    true
  )
  
  window.localStorage.getItem("preview") && promptSystemUpdate()
</script>

<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>
